import { getEnvValue } from 'configs/app/utils';

const chain = Object.freeze({
  redemptionV3: getEnvValue('NEXT_PUBLIC_GRAPHQL_NFT_REDEMPTION_V3_ENDPOINT'),
});

export default chain;
